module.exports = __webpack_public_path__ + "img/camera_w.5fecb73e.svg";